export default __webpack_public_path__ + "static/media/hero.a1127773.jpg";